import { buildTask as _buildTask } from "ember-concurrency/-private/async-arrow-runtime";
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { task } from 'ember-concurrency';
// eslint-disable-next-line ember/use-ember-data-rfc-395-imports

import { SLACK_V2_PLUGIN_KEY, MSTEAMS_V2_PLUGIN_KEY } from 'garaje/utils/enums';
import urlBuilder from 'garaje/utils/url-builder';
const ACCEPTABLE_CHAT_APP_PLUGINS = [SLACK_V2_PLUGIN_KEY, MSTEAMS_V2_PLUGIN_KEY];
let RoombaSettingsOnsiteRoomRecaptureComponent = (_class = class RoombaSettingsOnsiteRoomRecaptureComponent extends Component {
  constructor(owner, args) {
    // eslint-disable-next-line prefer-rest-params
    super(owner, args);
    _initializerDefineProperty(this, "flashMessages", _descriptor, this);
    _initializerDefineProperty(this, "graphql", _descriptor2, this);
    _initializerDefineProperty(this, "roombaMetrics", _descriptor3, this);
    _initializerDefineProperty(this, "state", _descriptor4, this);
    _initializerDefineProperty(this, "featureConfig", _descriptor5, this);
    _initializerDefineProperty(this, "isDialogOpen", _descriptor6, this);
    _initializerDefineProperty(this, "isOnsiteRoomRecaptureDisabled", _descriptor7, this);
    _initializerDefineProperty(this, "disabledMessage", _descriptor8, this);
    _initializerDefineProperty(this, "disabledMessageLink", _descriptor9, this);
    _defineProperty(this, "toggleOnsiteRoomRecaptureLocationEnabledTask", _buildTask(() => ({
      context: this,
      generator: function* () {
        const {
          company,
          location
        } = this.args;
        try {
          const onsiteRoomRecaptureEnabledSetting = !location.onsiteRoomRecaptureEnabled;
          this.roombaMetrics.trackEvent(`ROOMS:onsite_room_recapture_${onsiteRoomRecaptureEnabledSetting ? 'enabled' : 'disabled'}`, {
            location_id: location.id,
            company_id: company.id
          });
          yield this.graphql.updateRoomsLocationOnsiteRoomRecaptureEnabledOverride(location.id, onsiteRoomRecaptureEnabledSetting);
          this.flashMessages.showAndHideFlash('success', 'Saved!');
        } catch (e) {
          this.flashMessages.showAndHideFlash('error', 'Error saving location settings');
        }
        this.closeDialog();
      }
    }), {
      drop: true
    }, "toggleOnsiteRoomRecaptureLocationEnabledTask", null));
    _defineProperty(this, "toggleOnsiteRoomRecaptureCompanyEnabledTask", _buildTask(() => ({
      context: this,
      generator: function* () {
        const {
          company,
          location
        } = this.args;
        try {
          const onsiteRoomRecaptureEnabledSetting = !location.onsiteRoomRecaptureEnabled;
          this.roombaMetrics.trackEvent(`ROOMS:onsite_room_recapture_company_${onsiteRoomRecaptureEnabledSetting ? 'enabled' : 'disabled'}`, {
            location_id: location.id,
            company_id: company.id
          });
          yield this.graphql.updateRoomsCompanyOnsiteRoomRecaptureEnabled(company.id, onsiteRoomRecaptureEnabledSetting);
          this.flashMessages.showAndHideFlash('success', 'Saved!');
        } catch (e) {
          this.flashMessages.showAndHideFlash('error', 'Error saving company setting');
        }
        this.closeDialog();
      }
    }), {
      drop: true
    }, "toggleOnsiteRoomRecaptureCompanyEnabledTask", null));
    const {
      isOnsiteRoomRecaptureDisabled,
      disabledMessage,
      disabledMessageLink
    } = this.initializeDisabledState();
    this.disabledMessage = disabledMessage;
    this.isOnsiteRoomRecaptureDisabled = isOnsiteRoomRecaptureDisabled;
    this.disabledMessageLink = disabledMessageLink;
  }
  openDialog() {
    this.isDialogOpen = true;
  }
  closeDialog() {
    this.isDialogOpen = false;
  }
  initializeDisabledState() {
    const {
      location,
      plugins
    } = this.args;
    if (!this.featureConfig.isEnabled('rooms')) {
      throw new Error('No valid rooms subscription in state');
    }
    if (!location.onsiteRoomRecaptureEnabled && !this.featureConfig.isEnabled('roomMeetings.onSiteRoomRecapture')) {
      return {
        disabledMessage: 'Upgrade to the Standard Plan to access this feature.',
        isOnsiteRoomRecaptureDisabled: true,
        disabledMessageLink: urlBuilder.billingDashboardUrl()
      };
    }
    if (!this.state.currentCompany) {
      throw new Error('No valid current company in state');
    }
    const isChatAppInstalled = plugins.any(plugin => ACCEPTABLE_CHAT_APP_PLUGINS.includes(plugin.key));
    if (!location.onsiteRoomRecaptureEnabled && !isChatAppInstalled) {
      return {
        isOnsiteRoomRecaptureDisabled: true,
        disabledMessage: 'Install the Slack or Microsoft Teams app to enable this feature.',
        disabledMessageLink: urlBuilder.appStoreUrl()
      };
    }
    if (!this.state.currentLocation) {
      throw new Error('No valid current location in state');
    }
    const isProtectEnabled = this.state.currentLocation.isProtectSetup;
    if (!location.onsiteRoomRecaptureEnabled && !isProtectEnabled) {
      return {
        disabledMessage: 'Onsite room recapture requires Envoy Protect to track which employees have signed in for the day. Upgrade your Envoy Visitors subscription to include Envoy Protect.',
        isOnsiteRoomRecaptureDisabled: true,
        disabledMessageLink: urlBuilder.billingDashboardUrl()
      };
    }
    return {
      disabledMessage: undefined,
      disabledMessageLink: undefined,
      isOnsiteRoomRecaptureDisabled: false
    };
  }

  /**
   * @task `toggleOnsiteRoomRecaptureLocationEnabledTask`
   */

  /**
   * @task `toggleOnsiteRoomRecaptureCompanyEnabledTask`
   */
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "flashMessages", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "graphql", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "roombaMetrics", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "state", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "featureConfig", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "isDialogOpen", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "isOnsiteRoomRecaptureDisabled", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "disabledMessage", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "disabledMessageLink", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "openDialog", [action], Object.getOwnPropertyDescriptor(_class.prototype, "openDialog"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "closeDialog", [action], Object.getOwnPropertyDescriptor(_class.prototype, "closeDialog"), _class.prototype)), _class);
export { RoombaSettingsOnsiteRoomRecaptureComponent as default };